import Modal from './ModalImportFilePage';

export default Modal;
